import ApiService from "../api";

export default class SolicitacaoCompraService extends ApiService {

    constructor() {
        super('/api/solicitacoes/compras')
    }

    criarSolicitacao(dados) {
        return this.post(``, dados)
    }

    buscarDetalhe(solicitacaoId) {
        return this.get(`/${solicitacaoId}`)
    }

    editarSolicitacao(solicitacaoId, dados) {
        return this.put(`/${solicitacaoId}`, dados)
    }

    preencherCotacao(solicitacaoId, dados) {
        return this.put(`/${solicitacaoId}/cotacao`, dados)
    }

    salvarRascunhoCotacao(solicitacaoId, dados) {
        return this.put(`/${solicitacaoId}/cotacao/rascunho`, dados)
    }

    preencherOrdemCompra(solicitacaoId, dados) {
        return this.put(`/${solicitacaoId}/ordem-compra`, dados)
    }

    preencherRecebimento(solicitacaoId, dados) {
        return this.put(`/${solicitacaoId}/recebimento`, dados)
    }

    buscarPendentesRecebimento(fornecedorId) {
        return this.get(`/pendente-recebimento?fornecedorId=${fornecedorId}`)
    }

    buscarComplemento(excluirId, query) {
        const params = new URLSearchParams({ excluirId });
        if (query) params.append("query", query);
        return this.get(`/buscar-complemento?${params}`)
    }

    relatorio(filtros = {}) {
        const params = new URLSearchParams();
        Object.entries(filtros).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
        });
        return this.get(`/relatorio?${params}`);
    }

    dashboard(filtros = {}) {
        const params = new URLSearchParams();
        Object.entries(filtros).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== "") params.append(chave, valor);
        });
        return this.get(`/dashboard?${params}`);
    }
}
